import { Component } from '@angular/core';

@Component({
  selector: 'placeme-home-spirit',
  templateUrl: './home-spirit.component.html',
  styleUrls: ['./home-spirit.component.scss'],
})
export class HomeSpiritComponent {}
